import { render, staticRenderFns } from "./scienceYfList.vue?vue&type=template&id=029d8628&scoped=true&"
import script from "./scienceYfList.vue?vue&type=script&lang=js&"
export * from "./scienceYfList.vue?vue&type=script&lang=js&"
import style0 from "./scienceYfList.vue?vue&type=style&index=0&id=029d8628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029d8628",
  null
  
)

component.options.__file = "scienceYfList.vue"
export default component.exports